import AutoSuggestions from '../../Services/Queries/AutoSuggestions'

const AutoSuggestionsdata = async value => {
  try {
    const input = {
      search: value,
      type: 'person',
      limit: 100,
      from: 0,
    }
    const movieData = await AutoSuggestions(input)
    return movieData
  } catch (error) {
    return error
  }
}

export default AutoSuggestionsdata
